const bvc = {
  FORMS: [
    {
      type: 'bvc-contact-form',
      name: 'BvcContactForm',
      message: {
        open: 'Formulario contacto',
        send: 'Envío Formulario De Contacto'
      }
    }
  ],
  CSS: {
    id: '66cf918d7b531516ef36bdb1',
    name: 'bvc',
    avatar: {
      name: 'bvc',
      header: 'https://chatbotqa.gatblac.com/static/avatar/bvc/bvc.svg',
      new: 'https://chatbotqa.gatblac.com/static/avatar/nuam/Avatar-1.svg',
      open: 'https://chatbotqa.gatblac.com/static/avatar/nuam/Avatar-1.svg',
      close: 'https://chatbotqa.gatblac.com/static/avatar/nuam/Avatar-1.svg'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#2C5697',
        borderColor: '#2C5697'
      }
    }
  }
}

export default bvc
